import React, { useState, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/store';
import { flashMessageStore } from '@/store/flashMessage';
import { FlashMessage } from '../Presentation';
import { FLASH_MESSAGE_LIFETIME_MILLISEC } from '@/constants';

export const FlashMessageContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isWarning, body } = useAppSelector(
    flashMessageStore.selectors.flashMessageSelector,
  );

  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const erase = () => setVisible(false);

  useEffect(() => {
    if (!body) {
      return;
    }

    show();
    setTimeout(() => {
      erase();
      dispatch(flashMessageStore.actions.clear());
    }, FLASH_MESSAGE_LIFETIME_MILLISEC);
  }, [body, dispatch]);

  return (
    <FlashMessage
      body={body}
      isWarning={isWarning}
      visible={visible}
      erase={erase}
    />
  );
};
